import { MessageDto, MessageLogDto } from 'common/dto-types/message-dto';
import ListWithTotal from 'common/dto-types/list-with-total-dto';
import axiosServices, { buildQueryParams, PaginationAndFiltersParams } from 'utils/axios';

const MESSAGE_ENDPOINT = 'messages';
const GET_MESSAGE_HISTORY = 'messages/logs-list';

export const fetchMessageList = async (
    params: PaginationAndFiltersParams,
): Promise<ListWithTotal<MessageDto> | null> => {
    try {
        const res = await axiosServices.get(`${MESSAGE_ENDPOINT}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const getMessageById = async (messageId: number): Promise<MessageDto | null> => {
    try {
        const res = await axiosServices.get(`${MESSAGE_ENDPOINT}/${messageId}`);
        return res.data;
    } catch (err) {
        console.error(err);
        return null;
    }
};

export const createMessage = async (message: Partial<MessageDto>): Promise<MessageDto | null> => {
    try {
        const res = await axiosServices.post(MESSAGE_ENDPOINT, message);
        return res.data;
    } catch (err) {
        console.error(err);
        // Re-throw the error so the form can handle field-level validation errors
        throw err;
    }
};

export const updateMessage = async (messageId: number, message: Partial<MessageDto>): Promise<MessageDto | null> => {
    try {
        const res = await axiosServices.put(`${MESSAGE_ENDPOINT}/${messageId}`, message);
        return res.data;
    } catch (err) {
        console.error(err);
        // Re-throw the error so the form can handle field-level validation errors
        throw err;
    }
};

export const sendTestMessage = async (messageId: number, message: Partial<MessageDto>): Promise<MessageDto | null> => {
    try {
        const res = await axiosServices.post(`${MESSAGE_ENDPOINT}/${messageId}/test`, message);
        return res.data;
    } catch (err) {
        console.error(err);
        // Re-throw the error so the form can handle field-level validation errors
        throw err;
    }
};

export const publishMessage = async (messageId: number, message: Partial<MessageDto>): Promise<MessageDto | null> => {
    try {
        const res = await axiosServices.post(`${MESSAGE_ENDPOINT}/${messageId}/publish`, message);
        return res.data;
    } catch (err) {
        console.error(err);
        // Re-throw the error so the form can handle field-level validation errors
        throw err;
    }
};

export const deleteMessage = async (messageId: number): Promise<void> => {
    try {
        await axiosServices.delete(`${MESSAGE_ENDPOINT}/${messageId}`);
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const duplicateMessage = async (messageId: number): Promise<number> => {
    try {
        const res = await axiosServices.post(`${MESSAGE_ENDPOINT}/${messageId}/duplicate`);
        return res.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const recallMessage = async (messageId: number): Promise<void> => {
    try {
        const res = await axiosServices.post(`${MESSAGE_ENDPOINT}/${messageId}/recall`);
        return res.data;
    } catch (err) {
        console.error(err);
        throw err;
    }
};

export const fetchMessageHistoryList = async (
    params: PaginationAndFiltersParams
): Promise<ListWithTotal<MessageLogDto> | null | undefined> => {
    try {
        const res = await axiosServices.get(`/${GET_MESSAGE_HISTORY}${buildQueryParams(params)}`);
        return res.data;
    } catch (err) {
        console.error(err);
        return null;
    }
};
